import React from 'react'

const Card = ({ style, cssClass, children }) => (
    <div
        className={`salesInt-card widget ${cssClass ?? ''}`}
        style={style}
    >
        {children}
    </div>
)

export default Card
